const component = "site-details-card";

export const siteDetailsCard = {
  component,
  skeleton: `${component}/skeleton`,
  siteName: `${component}/site-name`,
  siteArea: `${component}/site-area`,
  electricityTarifs: {
    item: `${component}/electricity-tarifs/item`,
    tarifValue: `${component}/electricity-tarifs/tarif-value`,
    tarifType: `${component}/electricity-tarifs/tarif-type`,
  },
  editSiteDetailsButton: `${component}/edit-site-details-button`,
};
